export default __webpack_public_path__ + "static/media/Table-Piechart.08d1806c.svg";